import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl, FormattedMessage } from 'react-intl';

import Button from 'client/components/aria/Button/Button';

import styles from 'client/pages/MapPage/components/DynamicLegend/DynamicLegend.module.scss';
import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';
import Legend from 'client/pages/MapPage/components/Legend/Legend';
import { selectSectorSpecificStyles } from 'client/store/layersSlice/layersSlice';
import { selectShowDynamicLegend, setShowDynamicLegend } from 'client/store/mapSlice/mapSlice';
import useEscapeKeypress from 'client/utils/helpers/KeyHelpers/useEscapeKeypress';

const DynamicLegend = () => {
    const panelRef = useRef();
    const intl = useIntl();
    const dispatch = useDispatch();
    const sectorSpecificStyles = useSelector(selectSectorSpecificStyles);
    const showLegend = useSelector(selectShowDynamicLegend);
    const handleClose = () => {
        dispatch(setShowDynamicLegend(false));
    };
    useEscapeKeypress(handleClose);

    if (panelRef?.current) {
        panelRef.current.scrollTop = 0;
        panelRef.current.scrollLeft = 0;
    }

    return <div data-testid="dynamicLegend.panel" className={[styles.panel, (showLegend ? styles.open : null), 'govuk-main-wrapper'].join(' ')}>
        <div styles={styles.header}>
            <div className={styles.header} aria-hidden={!showLegend}>
                <h2 className={styles.heading}>
                    <FormattedMessage id="dynamicLegend.heading" />
                </h2>
                <Button data-testid="dynamicLegend.closeButton" className={styles.closeButton} variant="transparent" onPress={handleClose} aria-label={intl.formatMessage({ id: 'close' })}>
                    <Icon path={mdiClose} size={1} />
                </Button>
            </div>
        </div>
        <div className={styles.panelContent} ref={panelRef}>
            <Legend sectorSpecificStyles={sectorSpecificStyles} dynamicLegend={true} />
        </div>
    </div>;
};

export default DynamicLegend;
